var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 56,
    height: 56,
    rx: 4,
    fill: "#FFBC1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6291 19.5697C23.8084 19.4718 23.9991 19.6224 23.9991 19.8267V33.3825C23.9991 33.6058 23.8466 33.7946 23.6493 33.8988C23.6425 33.9024 23.6358 33.906 23.6291 33.9097L21.2791 35.2497C19.6391 36.1897 18.2891 35.4097 18.2891 33.5097V23.7797C18.2891 23.1497 18.7391 22.3697 19.2991 22.0497L23.6291 19.5697Z",
    fill: "#FFBC1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7219 22.1029C30.8922 22.1873 31 22.3609 31 22.551V35.7041C31 36.0726 30.615 36.3145 30.283 36.1546L26.033 34.107C25.86 34.0236 25.75 33.8485 25.75 33.6565V20.4462C25.75 20.0753 26.1396 19.8336 26.4719 19.9981L30.7219 22.1029Z",
    fill: "#FFBC1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 22.4901V32.2201C38 32.8501 37.55 33.6301 36.99 33.9501L33.4986 35.951C33.1653 36.1421 32.75 35.9014 32.75 35.5172V22.3304C32.75 22.1509 32.8462 21.9851 33.0021 21.8961L35.01 20.7501C36.65 19.8101 38 20.5901 38 22.4901Z",
    fill: "#FFBC1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.d48561289cc103d8ccf3033f64c7ff15.svg";
export { ForwardRef as ReactComponent };